<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-4.h6.basic800--text {{ $t('yezza_store_layouts') }}
        v-divider.basic300
        v-card-text.pa-0
          div.px-4.py-3
            div.d-flex.align-center
              div.s1.basic800--text {{ $t('default_layout') }}
              v-spacer
              v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" width="93" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="openLink(link)") {{ $t('view_layout') }}
            div.mt-1.c1.basic600--text {{ link }}
          v-divider.basic300
          div.px-4.py-3
            div.d-flex.align-center
              div.s1.basic800--text {{ $t('instagram_layout') }}
              v-spacer
              v-btn.button-AA-tiny.my-auto(color="textColorAccent" outlined x-small height="24" width="93" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="openLink(link+'instagram')") {{ $t('view_layout') }}
            div.mt-1.c1.basic600--text {{ link+'instagram' }}
          v-divider.basic300
        v-card-actions
          v-spacer
          v-btn.mr-2(color='basic100', text @click='showModal = false' height="32" width="64")
            .button-Aa-small.textColorAccent--text {{ $t('close') }}
</template>

<script>
export default {
  name: 'YezzaStoreThemes',
  props: ['open', 'link'],
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    openLink (link) {
      window.open(link)
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "yezza_store_layouts": "Yezza Store Layouts",
    "default_layout": "Default layout",
    "view_layout": "view layout",
    "instagram_layout": "Instagram layout"
  },
  "id": {
    "yezza_store_layouts": "Yezza Store Layouts",
    "default_layout": "Default layout",
    "view_layout": "lihat layout",
    "instagram_layout": "Instagram layout"
  }
}
</i18n>
